import React from "react";

const Article = () => {
  return (
    <div>
      <div className="mb-20">
        <h2 id="Awards">Awards</h2>
        <hr className="dividergeneral mb-5" />
        <p>
          Below are the awards we were honored to receive at the Jamboree in
          Paris.
        </p>
        <center>
          <div className="columnn space">
            <div className="separation mt-10">
              <img
                src={
                  "https://static.igem.wiki/teams/4888/wiki/goldmedallogo.svg"
                }
                alt="Our Medal"
                className="OurMedal separation"
              />
              <p className="ml-[5px]">
                Awarded
                <br />
                <b>Gold Medal</b>
              </p>
            </div>
            <div className="separation mt-10">
              <img
                src={"https://static.igem.wiki/teams/4888/wiki/bestedu.svg"}
                alt="Best Education"
                className="OurMedal separation"
              />
              <p className="ml-[5px]">
                Awarded
                <br />
                <b>Best Education Prize</b>
              </p>
            </div>
          </div>
          <div className="columnn space">
            <div className="separation mt-10">
              <img
                src={
                  "https://static.igem.wiki/teams/4888/wiki/track-therapeutics.svg"
                }
                alt="Our Medal"
                className="OurMedal separation"
              />
              <p className="ml-[5px]">
                Nominated
                <br />
                <b>Best Therapeutics Project</b>
              </p>
            </div>

            <div className="separation mt-10">
              <img
                src={
                  "https://static.igem.wiki/teams/4888/wiki/safetylogoaward.svg"
                }
                alt="Best Education"
                className="OurMedal separation"
              />
              <p className="ml-[5px]">
                Nominated
                <br />
                <b>Safety and Security Award</b>
              </p>
            </div>
          </div>
        </center>
      </div>

      <div>
        <h2 id="Medal Criteria"> Medal Criteria </h2>
        <hr className="dividergeneral mb-5" />
        <div className="mb-10">
          <img
            className="medal"
            src={"https://static.igem.wiki/teams/4888/wiki/goldmedal.png"}
            alt="Gold Medal"
          />
          <h3 id="Gold Medal" style={{ color: "#FCD075", marginLeft: "30px" }}>
            Gold Medal Criteria
          </h3>
          <hr style={{ borderColor: "#FCD075", borderWidth: "1px" }} />
          <p>
            This is awarded to those teams that have shown excellence beyond the
            Silver Medal in General Biological Engineering and chosen
            Specializations.
          </p>
          <b>Our chosen Special Prizes to compete for are:</b>

          <details>
            <summary>Education</summary>
            <hr style={{ borderWidth: "1.5px" }} />
            <img
              className="checkmark"
              src={"https://static.igem.wiki/teams/4888/wiki/checkbox1d.png"}
              alt="Checkmark"
            />
            <p style={{ marginLeft: "22px" }}>
              Describe how you have developed new opportunities to involve more
              individuals in influencing the field of synthetic biology.
            </p>
            <img
              className="checkmark"
              src={"https://static.igem.wiki/teams/4888/wiki/checkbox1d.png"}
              alt="Checkmark"
            />
            <p style={{ marginLeft: "22px" }}>
              Document your approach and what was learned by everyone involved
              to compete for this award.
            </p>
            <i>
              Checkout our{" "}
              <a className="linkTo" href="../epfl/education">
                {" "}
                Education Page{" "}
              </a>
            </i>
          </details>

          <details>
            <summary>Safety and Security</summary>
            <hr style={{ borderWidth: "1.5px" }} />
            <img
              className="checkmark"
              src={"https://static.igem.wiki/teams/4888/wiki/checkbox1d.png"}
              alt="Checkmark"
            />
            <p style={{ marginLeft: "22px" }}>
              Ensure the safe and secure utilization of synthetic biology to
              enable communities worldwide to address their specific local
              challenges.
            </p>
            <img
              className="checkmark"
              src={"https://static.igem.wiki/teams/4888/wiki/checkbox1d.png"}
              alt="Checkmark"
            />
            <p style={{ marginLeft: "22px" }}>
              Take the next incremental step, in advancing the knowledge,
              comprehension, and the development of tools aimed at enhancing the
              safety and security of synthetic biology applications.
            </p>
            <i>
              Checkout our{" "}
              <a className="linkTo" href="../epfl/safety">
                Safety Page{" "}
              </a>
            </i>
          </details>

          <details>
            <summary>New Composite Part</summary>
            <hr style={{ borderWidth: "1.5px" }} />
            <img
              className="checkmark"
              src={"https://static.igem.wiki/teams/4888/wiki/checkbox1d.png"}
              alt="Checkmark"
            />
            <p style={{ marginLeft: "22px" }}>
              Confirm whether the team has demonstrated the expected
              functionality of the part.
            </p>
            <img
              className="checkmark"
              src={"https://static.igem.wiki/teams/4888/wiki/checkbox1d.png"}
              alt="Checkmark"
            />
            <p style={{ marginLeft: "22px" }}>
              Assess its utility to the community.
            </p>
            <img
              className="checkmark"
              src={"https://static.igem.wiki/teams/4888/wiki/checkbox1d.png"}
              alt="Checkmark"
            />
            <p style={{ marginLeft: "22px" }}>
              Evaluate the level of characterization for this Basic Part when
              tested in a device.
            </p>
            <i>
              Checkout our{" "}
              <a className="linkTo" href="../epfl/parts">
                {" "}
                Parts Page{" "}
              </a>
              and our new composite part{" "}
              <a
                className="linkTo"
                href="http://parts.igem.org/Part:BBa_K4888005"
              >
                {" "}
                BBa_K4888005{" "}
              </a>
            </i>
          </details>
        </div>
        <div className="mb-10">
          <img
            className="medal"
            src={"https://static.igem.wiki/teams/4888/wiki/silvermedal.png"}
            alt="Silver Medal"
          />
          <h3
            id="Silver Medal"
            style={{ color: "#ADB9CA", marginLeft: "30px" }}
          >
            Silver Medal Criteria
          </h3>
          <hr style={{ borderColor: "#ADB9CA", borderWidth: "1px" }} />
          <p>
            This is awarded to those teams that have addressed these key pillars
            of an iGEM project: Engineering Success and Human Practices.
          </p>
          <b>All following criteria must be met:</b>

          <details>
            <summary>Engineering Success</summary>
            <hr style={{ borderWidth: "1.5px" }} />
            <img
              className="checkmark"
              src={"https://static.igem.wiki/teams/4888/wiki/checkbox1d.png"}
              alt="Checkmark"
            />
            <p style={{ marginLeft: "22px" }}>
              Demonstrate engineering success in a technical aspect of your
              project by going through at least one iteration of the engineering
              design cycle.{" "}
            </p>
            <i>
              Checkout our{" "}
              <a className="linkTo" href="../epfl/engineering">
                {" "}
                Engineering Page{" "}
              </a>
            </i>
          </details>

          <details>
            <summary>Human Practices</summary>
            <hr style={{ borderWidth: "1.5px" }} />
            <img
              className="checkmark"
              src={"https://static.igem.wiki/teams/4888/wiki/checkbox1d.png"}
              alt="Checkmark"
            />
            <p style={{ marginLeft: "22px" }}>
              Explain how you have determined your work is responsible and good
              for the world.{" "}
            </p>
            <i>
              Checkout our{" "}
              <a className="linkTo" href="../epfl/human-practices">
                {" "}
                Human Practices Page{" "}
              </a>
            </i>
          </details>

          <br></br>
        </div>
        <div className="mb-20">
          <img
            className="medal"
            src={"https://static.igem.wiki/teams/4888/wiki/bronzemedal.png"}
            alt="Bronze Medal"
          />
          <h3
            id="Bronze Medal"
            style={{ color: "#bf5416", marginLeft: "30px" }}
          >
            Bronze Medal Criteria
          </h3>
          <hr style={{ borderColor: "#bf5416", borderWidth: "1px" }} />
          <p>
            This is awarded to those teams that have participated in iGEM 2023,
            presented their work, and made a contribution for future teams.
          </p>
          <b>All following criteria must be met:</b>

          <details>
            <summary>Competition Deliverables</summary>
            <hr style={{ borderWidth: "1.5px" }} />
            <img
              className="checkmark"
              src={"https://static.igem.wiki/teams/4888/wiki/checkbox1d.png"}
              alt="Checkmark"
            />
            <p style={{ marginLeft: "22px" }}>
              Complete the following Competition Deliverables: Wiki, Project
              Promotion Video, Presentation Video, Judging Form, and Judging
              Session
            </p>
          </details>

          <details>
            <summary>Project Attributions</summary>
            <hr style={{ borderWidth: "1.5px" }} />
            <img
              className="checkmark"
              src={"https://static.igem.wiki/teams/4888/wiki/checkbox1d.png"}
              alt="Checkmark"
            />
            <p style={{ marginLeft: "22px" }}>
              Describe what work your team members did and what other people did
              for your project using the standardized form.{" "}
            </p>
            <i>
              Checkout our{" "}
              <a className="linkTo" href="../epfl/attributions">
                {" "}
                Attributions Page{" "}
              </a>
            </i>
          </details>

          <details>
            <summary>Project Description</summary>
            <hr style={{ borderWidth: "1.5px" }} />
            <img
              className="checkmark"
              src={"https://static.igem.wiki/teams/4888/wiki/checkbox1d.png"}
              alt="Checkmark"
            />
            <p style={{ marginLeft: "22px" }}>
              Describe how and why you chose your iGEM project.{" "}
            </p>
            <i>
              Checkout our{" "}
              <a className="linkTo" href="../epfl/description">
                {" "}
                Description Page{" "}
              </a>
            </i>
          </details>

          <details>
            <summary>Contribution</summary>
            <hr style={{ borderWidth: "1.5px" }} />
            <img
              className="checkmark"
              src={"https://static.igem.wiki/teams/4888/wiki/checkbox1d.png"}
              alt="Checkmark"
            />
            <p style={{ marginLeft: "22px" }}>
              Make a useful contribution for future iGEM teams.{" "}
            </p>
            <i>
              Checkout our{" "}
              <a className="linkTo" href="../epfl/contribution">
                {" "}
                Contribution Page{" "}
              </a>
            </i>
          </details>
        </div>
      </div>
    </div>
  );
};

export default Article;
